<template>

  <Card style="height: 490px; ">
    <Row slot="title" class="top-title">
      <Col span="3" class="title-span">
        <Tag v-if="listData.category =='M'" color="volcano">{{ listData.categoryName }}</Tag>
        <Tag v-else color="primary">{{ listData.categoryName }}</Tag>
      </Col>
      <Col span="8" class="title-span textover">
        <span style="font-size: 14px;" class=""><strong>{{ listData.name }}</strong></span>
      </Col>

      <Col
        span="3" class="title-span textover"
        :offset="2" @click="getInfo"
      >
        <Icon
          type="ios-alert-outline" size="13"
          color="#105cfb"
        />
        <span class="span-color " @click="getInfo">工商信息</span>
      </Col>
      <Col
        v-if="listData.property !=='P'" span="3"
        class="title-span textover" @click="getInfo"
      >
        <Icon
          type="ios-alert-outline" size="13"
          color="#105cfb"
        />
        <span class="span-color " @click="getBusinessInfo">同步信息</span>
      </Col>
      <Col span="3" class="title-span textover">
        <Icon
          type="ios-create-outline " size="13"
          color="#105cfb"
        />
        <span class="span-color " @click="changeInfo">修改</span>
      </Col>
      <Col span="3" class="title-span textover">
        <Icon
          type="ios-trash-outline " size="13"
          color="#105cfb"
        />
        <span class="span-color " @click="deleteParties">删除</span>
      </Col>
    </Row>

    <Row
      :gutter="16"
      class="bottom-Row" style="margin-top:0"
    >
      <Col :span="keyWith" class="center">
        经营性质：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.propertyName }}
      </Col>
    </Row>
    <Row :gutter="16" class="bottom-Row">
      <Col :span="keyWith" class="center">
        主体名称：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.name }}
      </Col>
    </Row>
    <Row
      v-if="listData.category =='S'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        主体标签：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.typeName }}
      </Col>
    </Row>
    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        信用代码：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.creditCode }}
      </Col>
    </Row>
    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        {{ listData.property =='I'?'经营者:':'法定代表人:' }}
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.legalRepresentative }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        {{ listData.property =='I'?'经营者身份证:':'法定代表人身份证:' }}
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.legalIdNo }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S' && listData.property == 'P'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        身份证号:
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.creditCode }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S' && listData.property == 'E' || listData.category =='S' && listData.property == 'I' " :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        信用代码：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.creditCode }}
      </Col>
    </Row>
    <Row
      v-if="listData.category =='S' && listData.tortCategory == 2" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        订单号：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.platformOrderNo }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S' && listData.property == 'E'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        法定代表人:
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.legalRepresentative }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S' && listData.property == 'I'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        经营者:
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.legalRepresentative }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S' && listData.property == 'I'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        经营者身份证号:
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.legalIdNo }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        联系方式：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.contact }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        主体区域：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.provinceName }} {{ listData.cityName }} {{ listData.areaName }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        工商登记地址：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.address }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        认定依据图片：
      </Col>
      <Col :span="valueWith" class="textover">
        <file-upload :default-list="listData.attachmentList || []" :upload-config="{readOnly:true}" />
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        认定依据描述：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.identifyRemark }}

      </Col>
    </Row>

    <Row
      v-if="listData.category =='S'" :gutter="16"
      class="bottom-Row" style="margin-bottom: 0;"
    >
      <Col :span="keyWith" class="center">
        状态：
      </Col>
      <Col :span="valueWith">
        <Tag v-if="listData.auditStateName == '审核通过'" color="success">审核通过</Tag>
        <Tag v-else-if="listData.auditStateName == '待审核'" color="warning">待审核</Tag>
        <Tag v-else color="error">被驳回</Tag>
      </Col>
    </Row>
    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        联系方式：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.contact }}
      </Col>
    </Row>
    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center">
        主体区域：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.provinceName }} {{ listData.cityName }} {{ listData.areaName }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        工商登记地址：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.address }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        认定依据图片：
      </Col>
      <Col :span="valueWith" class="textover">
        <file-upload :default-list="listData.attachmentList || []" :upload-config="{readOnly:true}" />
      </Col>
    </Row>

    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row"
    >
      <Col :span="keyWith" class="center textover">
        认定依据描述：
      </Col>
      <Col :span="valueWith" class="textover">
        {{ listData.identifyRemark }}
      </Col>
    </Row>

    <Row
      v-if="listData.category =='M'" :gutter="16"
      class="bottom-Row" style="margin-bottom: 0;"
    >
      <Col :span="keyWith" class="center">
        状态：
      </Col>
      <Col :span="valueWith">
        <Tag v-if="listData.auditStateName == '审核通过'" color="success">审核通过</Tag>
        <Tag v-else-if="listData.auditStateName == '待审核'" color="warning">待审核</Tag>
        <Tag v-else color="error">被驳回</Tag>
      </Col>
    </Row>

    <Row
      v-if="listData.category =='M' &&!(listData.name && listData.legalRepresentative &&( listData.provinceName|| listData.cityName || listData.areaName)&& listData.address&&listData.identifyRemark) " :gutter="16"
      class="bottom-Row" style="margin-bottom: 0;"
    >
      <Col span="12" class="center textover">
        <p style="font-size: 12px; color:#FF0000">缺失重要信息，请及时完善信息</p>
      </Col>
    </Row>
    <Row
      v-if="listData.category =='S'&& listData.property == 'P' && !(listData.name &&listData.contact && ( listData.provinceName|| listData.cityName || listData.areaName) && listData.address) " :gutter="16"
      class="bottom-Row" style="margin-bottom: 0;"
    >

      <Col span="12" class="center textover">
        <p style="font-size: 12px; color:#FF0000">缺失重要信息，请及时完善信息</p>
      </Col>
    </Row>

    <Row
      v-if="listData.category =='S'&& listData.property == 'E' && !(listData.name &&listData.legalRepresentative &&( listData.provinceName|| listData.cityName || listData.areaName)&& listData.address)" :gutter="16"
      class="bottom-Row" style="margin-bottom: 0;"
    >
      <!-- &&(listData.tortCategory == 2 ? listData.platformOrderNo : true) -->
      <Col span="12" class="center textover">
        <p style="font-size: 12px; color:#FF0000">缺失重要信息，请及时完善信息</p>
      </Col>
    </Row>
    <Row
      v-if="listData.category =='S'&& listData.property == 'I' && !(listData.name &&listData.legalRepresentative && ( listData.provinceName|| listData.cityName || listData.areaName)&& listData.address )" :gutter="16"
      class="bottom-Row" style="margin-bottom: 0;"
    >
      <Col span="12" class="center textover">
        <p style="font-size: 12px; color:#FF0000">缺失重要信息，请及时完善信息</p>
      </Col>
    </Row>
  </Card>

</template>
<script>
export default {
  props: {
    listData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      keyWith: 6,
      valueWith: 18

    }
  },
  beforeMount() {
    // console.log(this.listData, 'listData111111111111')
  },
  methods: {
    emitData(key, val) {
      this.$emit('emitData', key, val)
    },

    deleteParties() {
      // console.log('emitData', 11)
      this.$emit('emitData', 'optionCtrl', true)
      this.$emit('emitData', 'id', this.listData.id)
      this.$emit('emitData', 'modalTitle', '删除')
    },
    getInfo() {
      // console.log('getInfo', 111)
      this.$emit('emitData', 'isAdd', false)
      this.$emit('emitData', 'activeObj', this.listData)
      this.$emit('getDetail')
      // this.getDetail()
    },
    changeInfo() {
      this.$emit('rowOption', this.listData, 'edit')
    },
    getBusinessInfo() {
      this.$emit('emitData', 'optionCtrl', true)
      this.$emit('emitData', 'id', this.listData.id)
      this.$emit('emitData', 'modalTitle', '同步工商信息')
    }
  }
}
</script>

  <style lang="scss" scoped>
.top-title {
  // background-color:#f7f7f7;
  display: flex;
  .title-span {
    line-height: 32px;
  }
  .span-color {
    color: #0b5afa;
    cursor: pointer;
  }
}
.bottom-Row {
  margin-top: 8px;
  margin-bottom: 8px;
}
.center {
  text-align: end;
  font-size: 12px;
  color: #808695;
}
/deep/.ivu-card-head {
  border-bottom: 1px solid #ebeaf0;
  padding: 6px 15px;
  line-height: 1;
  background-color: #f6f6f6;
}
.textover {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/view/clue/myClue/plugin/litigantList.vue